// extracted by mini-css-extract-plugin
var _1 = "footer-row__weYxS";
export { _1 as "footerRow" }
